import React from "react";

function Media() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Media</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              This is a fairly developing area in the field of law.  It mainly involves types of work such as contract negotiation on behalf of broadcasters and television corporations.  It can also arise to matters of dispute such as intellectual property infringement and contractual disputes.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Media;
